import React from "react";
import Alert from "./Alert";

export default ({ key, children, position = "fixed" }) => (
  <Alert key={key} appearance="success" position={position}>
    {children}
  </Alert>
);
